export const categories = [
  {
    slug: "91-video",
    name: "91视频",
    description: "91视频专区，汇聚海量高清影视资源，涵盖热门电影、电视剧、综艺等精彩内容，每日更新不重样。",
    icon: "ri-movie-2-line",
  },
  {
    slug: "97-video",
    name: "97视频",
    description: "97视频专区，精选优质视频内容，包括纪录片、动漫、短片等多元化数字视频，满足您的观影需求。",
    icon: "ri-clapperboard-line",
  },
  {
    slug: "51-video",
    name: "51视频",
    description: "51视频专区，为您提供最新最全的视频资源，支持高清流畅在线观看，畅享数字视频的无限魅力。",
    icon: "ri-play-list-2-line",
  },
  {
    slug: "hot-video",
    name: "热门推荐",
    description: "编辑精选热门视频推荐，汇集全网最受欢迎的视频内容，让精彩不再错过。",
    icon: "ri-fire-line",
  },
  {
    slug: "new-video",
    name: "最新上线",
    description: "实时更新最新上线的视频内容，第一时间为您呈现新鲜视频资源，紧跟视频潮流。",
    icon: "ri-timer-line",
  },
];